module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_21.3f11ef28.pdf";